module.exports = __webpack_public_path__ + "assets/3Wz2M38Oep.woff2";